import { FC } from 'react';
import { Box } from '@qga/roo-ui/components';
import BookingAlert from 'components/BookingAlert';
import { SelfServiceAPI } from 'types';

interface CancelledStateMessageProps {
  booking: SelfServiceAPI.Booking;
}

const CancelledStateMessage: FC<CancelledStateMessageProps> = ({ booking }) => {
  if (!booking.flags.isCancelled) {
    return null;
  }

  const { email } = booking.travelArranger;

  return (
    <BookingAlert icon="cancel">
      <Box display={['block', 'inline']}>
        <strong>Your booking has been cancelled.</strong>
      </Box>{' '}
      A confirmation email has been sent to <strong>{email}</strong>
    </BookingAlert>
  );
};

export default CancelledStateMessage;
